import React from "react";
import { Container, Row, Col } from "shards-react";
import Policies from "../components/contracts/policies/Policies";

const PoliciesTable = () => (
  <Container fluid className="main-content-container px-4">
	  <Row>
      <Col className="p-2">
		    <Policies /> 
      </Col>
    </Row>
   </Container>
);

export default PoliciesTable;
